import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { menuOptions } from 'src/data/menu-options.data';
import { HomeComponent } from '../../home/home.component';
import { RequestHistoryService } from 'src/app/services/requests/history/request-history.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  ConfirmDialogComponent,
  DataObjectConfirmDialog
} from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { AccessService } from 'src/app/services/common/access-common.service';

@Component({
  selector: 'spe-importar-arquivo-v2',
  templateUrl: './importar-arquivo-v2.component.html',
  styleUrls: ['./importar-arquivo-v2.component.scss'],
  standalone: false
})
export class ImportarArquivoV2Component implements OnInit {
  private subscriptions: Subscription[] = [];
  public site = localStorage.getItem('site');
  public isCaixa = localStorage.getItem('sigla') == 'CAIXA';
  public sigla = localStorage.getItem('sigla');
  @ViewChild('materialApoioTemplate') materialApoioTemplate: TemplateRef<any> | undefined;

  constructor(
    public readonly routerService: Router,
    private homeComponent: HomeComponent,
    private requestHistoryService: RequestHistoryService,
    private dialog: MatDialog,
    public accessService: AccessService
  ) {}

  ngOnInit(): void {
    this.homeComponent.setNewVariables(
      'Importação',
      `No site da ${this.site} você pode importar arquivos para gerar o seu pedido.`
    );
    this.homeComponent.idleMenuContent = menuOptions[3].content;
    this.homeComponent.iconPath = 'assets/images/64_icon_earth_upload.png';

    if (this.accessService.isSIGUser() && !this.accessService.isImportSIGUser()) {
      this.routerService.navigate([`home/relatorios/opcoes`], {
        queryParams: { reportFilter: 'Importação' }
      });
    }

    let subscription = this.requestHistoryService.listarProcessamentos().subscribe({
      next: (data) => {
        if (data != null) {

          const queryParams = {
              ...(data.importacaoEmAndamento && { importacao: 'S' })
            };

          //return this.routerService.createUrlTree(['home/pedidos/acompanhamento/reprocessamento'], { queryParams });
          this.routerService.navigate(['home/pedidos/acompanhamento/reprocessamento'], { queryParams });
        }
      },
      error: () => {}
    });
    this.subscriptions.push(subscription);
  }

  public readonly goTo = (path: string) => {
    this.routerService.navigate([`home/importacao/importar-arquivo/${path}`]);
  };

  public readonly returnButton = () => {
    this.routerService.navigate([`home/gerar-pedidos`]);
  };

  public openMaterialApoioDialog = () => {
    const data: DataObjectConfirmDialog = {
      title: 'Material de apoio',
      component: this.materialApoioTemplate,
      noActionsFooter: true
    };
    const materialApoioDialogConfig: MatDialogConfig<any> = {
      panelClass: 'full-bleed-dialog',
      width: '600px',
      data: data,
      autoFocus: false
    };
    this.dialog.open(ConfirmDialogComponent, materialApoioDialogConfig);
  };

  public manualPadrao = () => {
    const pdfURL = 'assets/manual-importacao-apb.pdf';
    window.open(pdfURL, '_blank');
  };

  public manualCSV = () => {
    const pdfURL = 'assets/manual-importacao-csv.pdf';
    window.open(pdfURL, '_blank');
  };
}
